import maplibregl from 'maplibre-gl'

/**
 * Single viewport bounds for Cameroon:
 *  - used as `maxBounds` (hard pan/zoom lock)
 *  - used as `fitBounds` target to frame the full country
 * MapLibre automatically derives minZoom from these bounds.
 */
export const CAMEROON_BOUNDS_SW: [number, number] = [-1.18224, 0.83438]
export const CAMEROON_BOUNDS_NE: [number, number] = [24.11895, 13.53901]

/** Flat [west, south, east, north] for style metadata or external consumers. */
export const CAMEROON_BOUNDS_W_S_E_N: [number, number, number, number] = [
  CAMEROON_BOUNDS_SW[0],
  CAMEROON_BOUNDS_SW[1],
  CAMEROON_BOUNDS_NE[0],
  CAMEROON_BOUNDS_NE[1],
]

/**
 * Default padding when calling fitBounds to frame the full country.
 * Use asymmetric padding so the visible part of Cameroon stays centered
 * even when the left sidebar (icon bar + 24rem content panel) is open.
 */
export const CAMEROON_MAP_VIEW_FIT_PADDING: number | maplibregl.PaddingOptions = {
  top: 40,
  right: 40,
  bottom: 40,
  left: 440,
}

export function createCameroonLngLatBounds(): maplibregl.LngLatBounds {
  return new maplibregl.LngLatBounds(CAMEROON_BOUNDS_SW, CAMEROON_BOUNDS_NE)
}

/** Alias kept for readability at call sites that set maxBounds. */
export const createCameroonMaxPanBounds = createCameroonLngLatBounds
